// correctAnswerMapping.js

export const correctAnswerMapping = {
    A: 'option_1_text',
    B: 'option_2_text',
    C: 'option_3_text',
    D: 'option_4_text',
  };
  